module.exports = __webpack_public_path__ + "img/tabs-01.f16c1f08.jpg";